import React, { useState } from "react";
import { Box, Tab, Tabs, Typography, alpha } from "@mui/material";
import { motion } from "framer-motion";
import HomeLayout from "../../asset/layout/HomeLayout";
import { BackendUser } from "./BackendUser";
import SuperAdmin from "./SuperAdmin";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";

const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: [0.22, 1, 0.36, 1] } },
};

const UsersTab = () => {
  const [value, setValue] = useState(0);

  return (
    <HomeLayout>
      <Box
        sx={{
          minHeight: "100%",
          background:
            "linear-gradient(180deg, #f0f4fa 0%, #f5f7fa 35%, #eef2f7 100%)",
          mx: -3,
          mt: -3,
          px: 3,
          pt: 3,
          pb: 4,
        }}
      >
        <motion.div initial="hidden" animate="visible" variants={fadeUp}>
          <Box
            sx={{
              p: { xs: 3, md: 4 },
              mb: 3,
              borderRadius: "24px",
              background:
                "linear-gradient(135deg, #0c3483 0%, #11409B 40%, #1e40af 70%, #2563eb 100%)",
              color: "#fff",
              position: "relative",
              overflow: "hidden",
              boxShadow: "0 20px 60px rgba(17, 64, 155, 0.35)",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: -50,
                right: -30,
                width: 200,
                height: 200,
                borderRadius: "50%",
                bgcolor: alpha("#fff", 0.06),
              }}
            />
            <Box sx={{ position: "relative", zIndex: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                <AdminPanelSettingsOutlinedIcon />
                <Typography
                  variant="caption"
                  sx={{ fontWeight: 600, letterSpacing: "0.1em", opacity: 0.85 }}
                >
                  ACCESS CONTROL
                </Typography>
              </Box>
              <Typography
                variant="h4"
                sx={{ fontWeight: 800, letterSpacing: "-0.03em" }}
              >
                Backend users
              </Typography>
              <Typography sx={{ mt: 1, opacity: 0.82, maxWidth: 560 }}>
                Manage manager accounts with module permissions, or view super
                admin profiles in one place.
              </Typography>
            </Box>
          </Box>
        </motion.div>

        <Box
          sx={{
            mb: 3,
            bgcolor: "#fff",
            borderRadius: "16px",
            border: `1px solid ${alpha("#11409B", 0.1)}`,
            boxShadow: "0 4px 24px rgba(15, 23, 42, 0.05)",
            px: 1,
          }}
        >
          <Tabs
            value={value}
            onChange={(_, newValue) => setValue(newValue)}
            aria-label="user management tabs"
            sx={{
              minHeight: 48,
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.95rem",
                color: "#64748b",
                minHeight: 48,
              },
              "& .Mui-selected": { color: "#11409B" },
              "& .MuiTabs-indicator": {
                height: 3,
                borderRadius: "3px 3px 0 0",
                bgcolor: "#11409B",
              },
            }}
          >
            <Tab label="Managers" />
            <Tab label="Super Admin" />
          </Tabs>
        </Box>

        {value === 0 ? <BackendUser /> : <SuperAdmin />}
      </Box>
    </HomeLayout>
  );
};

export default UsersTab;
